module.exports = __webpack_public_path__ + "static/media/BlinkDagger.5c587303.png";